import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getQiwaContractData = createAsyncThunk(
  "api/qiwaContract",
  async (token, type) => {
    try {
      const response = await nodeinstance.get("/qiwaContract", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const QiwaContractDataSlice = createSlice({
  name: "insurance",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQiwaContractData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getQiwaContractData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQiwaContractData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getQiwaContractData };
export default QiwaContractDataSlice.reducer;
